import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_HubAdjustmentRateList = _resolveComponent("HubAdjustmentRateList");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}later_use_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formattedLaterUseYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}distance_product`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formattedDistanceProduct), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_worker_support_amount`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsWorkerSupportAmount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_customer_message_service`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsCustomerMessageService), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_delivery_status`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsDeliveryStatus), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_v_divider, { class: "my-2" }),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubDetailLc}adjustment_rate`),
            "wide-title": "",
            "is-vertical-label": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_HubAdjustmentRateList, {
                    class: "my-2",
                    items: _ctx.hubAdjustmentRateList
                }, null, 8 /* PROPS */, ["items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
